import React from "react";
import "../css/base.css";
import "../css/alert.css";
import alert_img from "../img/alert.gif";

const AlertDiscord = props => {
  const {
    isRegisteredId,
    oldAddress,
    newAddress,
    discordId,
    teamName,
    closeAction,
    updateDicoInfo
  } = props;

  const handleClose = () => {
    closeAction();
  };

  const handleOk = () => {
    if (!isRegisteredId) {
      updateDicoInfo(newAddress, discordId, teamName);
    }
    closeAction();
  };

  const shortAddres = _address => {
    let rtVal = "";
    if (_address != undefined && _address.length > 0) {
      rtVal =
        _address.substring(0, 6) +
        "      ...      " +
        _address.substring(_address.length - 4, _address.length);
    }
    return rtVal;
  };

  return (
    <div id="discord_id_check">
      <img src={alert_img} alt="" />
      <p id="discord_id_check_tit">LEEDO Project Discord ID</p>
      <p id="discord_id_check_ID">{discordId}</p>
      {isRegisteredId ? (
        <>
          <p className="discord_id_check_dsc">
            {discordId} has another registered address already.
          </p>
          <p className="discord_id_check_address">{shortAddres(oldAddress)}</p>

          <p className="discord_id_check_dsc">
            Make sure your wallet address is correct.
            <br />
            To change the address associated with {discordId}, please create a
            ticket in the #🎟︲ticket channel on the Leedo Project Discord.
          </p>
          {/* <p className="discord_id_check_dsc">지금 주소로 변경하시겠습니까?</p> */}
          {/* <p className="discord_id_check_address">{newAddress}</p> */}
        </>
      ) : (
        <>
          <p className="discord_id_check_dsc">
            Would you like to register your address to {discordId}?
          </p>
          <p className="discord_id_check_address">{shortAddres(newAddress)}</p>
        </>
      )}
      <div id="discord_id_check_btn">
        <button type="button" name="cancle" onClick={handleClose}>
          Cancel
        </button>
        <button type="button" name="ok" onClick={handleOk}>
          OK
        </button>
      </div>
    </div>
  );
};
export default AlertDiscord;
